import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import { listPacks } from "@/services/pack/list-packs";
import { openPack } from "@/services/pack/open-pack";
import { queryKeys } from "./query-keys";

export const usePacks = () => {
  const { state } = useAuth();

  return useQuery({
    queryKey: queryKeys.packs,
    queryFn: async () => {
      const response = await listPacks();
      if (!response.ok) throw new Error(response.message);
      return response.data.packs;
    },
    enabled: state.status === "authenticated",
  });
};

export const useOpenPack = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: openPack,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.packs });
      queryClient.invalidateQueries({ queryKey: queryKeys.inventoryPokemons });
      queryClient.invalidateQueries({ queryKey: queryKeys.inventoryEnergy });
      queryClient.invalidateQueries({ queryKey: queryKeys.inventoryItemCards });
    },
  });
};
